module.exports = __webpack_public_path__ + "img/ic_store_trait_top_img2.2844c4f6.png";